module.exports = __webpack_public_path__ + "static/media/van.facc4b84.png";